import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LogoutPageComponent } from "./logout-page.component";

@NgModule({
  declarations: [LogoutPageComponent],
  imports: [CommonModule],
  exports: [LogoutPageComponent],
})
export class LogoutPageModule {}
